<template>
  <div class="empty" :class="{ 'empty--has-icon': icon }">
    <fa-icon v-if="icon" :icon="icon" size="2x"></fa-icon>

    <p class="spire-empty-state__message">
      <em>
        <slot>
          {{ message }}
        </slot>
      </em>
    </p>
    <slot name="action"></slot>
  </div>
</template>
<script setup lang="ts">
interface Props {
  message?: string;
  icon?: string;
}
defineProps<Props>();
</script>
